module.exports = __webpack_public_path__ + "img/razzo.ecdcaf01.jpg";